module.exports = __webpack_public_path__ + "static/testing-4f088a157f58cffdbb784b3adcd675eb.svg";